export default {
  cnumber1: '角色列表',
  cnumber2: '子账号列表',
  cnumber3: '角色标识',
  cnumber4: '角色名称',
  cnumber5: '角色权限',
  cnumber6: '启用',
  cnumber7: '禁用',
  cnumber8: '是否删除？',
  cnumber9: '子账号状态',
  cnumber10: '添加子账号',
  cnumber11: '子账号ID',
  cnumber12: '角色',
  cnumber13: '最新登录时间',
  cnumber14: '权限',
  cnumber15: '修改子账号',
  cnumber16: '角色菜单',
  cnumber17: '批量分配',
  cnumber18: '请先选择订单',
  cnumber19: '订单分配',
  cnumber20: '子账号',
  cnumber21: '订单同捆',
  cnumber22: '批次表',
  cnumber23: '所有（可以操作所有账号的数据）',
  cnumber24: '自己',
  cnumber25: '角色状态',
  cnumber26: '此操作将',
  cnumber27: '是否继续？',
  cnumber28: '请输入6-20位数字与字母组合的密码',
  cnumber29: '充值账号',
  cnumber30: '负责人',
  cnumber31: '所有（可以查看所有账号的数据）',
};
